var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M20.84 3.03L21 3C21.28 3 21.5 3.22 21.5 3.5V18.62C21.5 18.85 21.35 19.03 21.14 19.1L15.5 21L9.5 18.9L4.16 20.97L4 21C3.72 21 3.5 20.78 3.5 20.5V5.38C3.5 5.15 3.65 4.97 3.86 4.9L9.5 3L15.5 5.1L20.84 3.03ZM9.5 16.89L15.5 19V7.11L9.5 5V16.89Z"
  }))));
};
export default SvgMap;